import React from 'react';
import './NotFound.scss'
import PageShell from "../layout/PageShell";
import PageHead from "../layout/PageHead";

const NotFound = () => (
    <PageShell><PageHead title="Not found" /><div className="list">
        <div className="listContainer">
            <div className='not-found'>
                <h1>404</h1>
                <h3>Page Not Found</h3>
            </div>

        </div>
    </div></PageShell>
);
export default NotFound;